import React, { useState } from "react";
import "../../assets/css/sign.css";
import logo from "../../assets/AdityaBirlaGroupLogoVector.svg";
import mainBanner from "../../assets/MainBanner.svg";
import { useNavigate } from "react-router-dom";

import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import Loader from "../../Components/LoaderAndSpinner/Loader";

const ForgetPassword = () => {
  const [loading, setLoading] = useState(false);
  const [email, setEmail] = useState("");
  const [errors, setErrors] = useState({});
  const navigate = useNavigate();

  const handleSubmit = async (event) => {
    event.preventDefault();
    setLoading(true);
    setErrors({});

    try {
      const formattedEmail = email.trim() + "@aeriesys.com";

      const response = await fetch(
        `${process.env.REACT_APP_BASE_API_URL1}/api/v1/forgot-password`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ email: formattedEmail }),
        }
      );

      if (!response.ok) {
        const errorData = await response.json();


        const errorMessaged = errorData.message

        setErrors(errorData.errors || {});
        toast.error(errorMessaged);
        setLoading(false);
        return
      }

      navigate("/auth/changePassword");

    } catch (error) {
      console.error("Error occurred:", error);
      toast.error("Error occurred");
    }

    setLoading(false);
  };

  const currentYear = new Date().getFullYear();

  return (
    <>
      {loading ? <Loader /> : ""}
      <div className="container  bg-white">
        <div>
          <div className="row signIn-card">
            <div className="col-lg-6 p-0 pt-4 col-md-12 px-4  mb-4 resp-img">
              <img src={mainBanner} alt="bg-image" className="resp-img-img" />
              <img src={logo} className="banner-logo desktop-logo" alt="logo" />
              <div className="banner-text-container">
                <h1 className="banner-text1">Asset Taxonomy Management</h1>
                <h3 className="banner-text2">ATM - version 1.0</h3>
              </div>
            </div>
            <div className="col-lg-6 col-md-12  p-0 px-4 signin-col align-content-center ">
              <h2>Forgot Password</h2>
              <p>
                Please enter your email address. You will receive an OTP to
                create a new password via email
              </p>
              <form className="signin-form needs-validation" onSubmit={handleSubmit} noValidate>
                <div
                  className="d-flex flex-column"
                  style={{ marginBottom: "16px", position: "relative" }}
                >
                  <label htmlFor="email" className="signin-form-label">
                    Email Id
                  </label>
                  <input
                    id="email"
                    name="email"
                    placeholder="Enter your email"
                    className={`signin-form-input ${errors.email ? "is-invalid" : ""
                      }`}
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    autoComplete="off"
                  />
                  <p className="email-p">@adityabirla.com</p>
                  {errors.email && (
                    <div className="invalid-feedback">{errors.email}</div>
                  )}
                </div>
                <button type="submit" className="signin-form-button">
                  SEND OTP
                </button>
              </form>
            </div>
          </div>
          <div className="d-flex justify-content-between align-content-center  px-4  sign-footer-text">
            <p className="w-100">Copyright all rights reserved {currentYear}</p>
            <div className="w-100 d-flex gap-5 justify-content-end sign-footer-text-1 ">
              <p>Terms Of Use</p>
              <p>Privacy Policy</p>
            </div>
          </div>
        </div>
      </div>

      <ToastContainer autoClose={4000} position={"top-right"} />
    </>
  );
};

export default ForgetPassword;
